export const CROSS_SUBJECT_DESCRIPTION = `
Enhance your lesson by incorporating concepts both within and across the curriculum. 
This will enable your students to establish meaningful connections between different learning areas.`;

export const CROSS_SUBJECT_HEADINGS = ['Cross-Subject Extensions:', 'Details:']
export const CROSS_SUBJECT_SECTION = 'Subject'
